<main [ngStyle]="{ height: innerHeight + 'px', 'min-height': innerHeight + 'px' }">
  <router-outlet class="exclude-height"></router-outlet>

  <div
    class="generic-sidebar-as-window"
    [ngClass]="{
      shown: isSidebarAsWindowOpen,
      backdrop: isSidebarAsWindowOpen && !hideBackDrop,
      md: isWindowMd,
      'fill-mobile': isWindowFillMobile,
      'd-none d-xl-block': !isWindowMd
    }"
    [ngStyle]="{ 'z-index': sidebarAsWindowCustomZIndex }"
  >
    <aside class="data-sidebar-as-window">
      <div class="sidebar-as-window-body">
        <div #sidebarAsWindowForm></div>
      </div>
    </aside>
  </div>

  <div
    class="generic-sidebar d-print-none"
    [ngClass]="{
      shown: isSidebarOpen,
      backdrop: isSidebarOpen && !hideBackDrop,
      lg: isLg,
      xlg: isXlg,
      'is-purple': isPurple
    }"
    [ngStyle]="{ 'z-index': customZIndex }"
  >
    <aside class="data-sidebar">
      <div class="sidebar-header" *ngIf="isSidebarOpen">
        <div class="sidebar-header-text">
          <ng-container *ngIf="!isSidebarHeaderTitleCase">
            {{ sidebarHeaderText | translate }}
          </ng-container>

          <ng-container *ngIf="isSidebarHeaderTitleCase">
            {{ sidebarHeaderText | translate | titlecase }}
          </ng-container>

          <app-hint-tooltip-icon *ngIf="!!tooltipText" [hint]="tooltipText | translate"></app-hint-tooltip-icon>
        </div>
        <div class="sidebar-header-close" (click)="closeSidebar(true)">×</div>
      </div>

      <div class="sidebar-body">
        <div #sidebarForm></div>
      </div>
    </aside>
  </div>
</main>
<div class="custom-ui">
  <alert></alert>
  <filing-restricted-modal></filing-restricted-modal>
  <company-profile-incomplete-modal></company-profile-incomplete-modal>
  <div class="custom-loader">
    <request-loader></request-loader>
  </div>
</div>
